import React, { useState, useEffect } from 'react';

const API_URL = 'https://metapi.emedhatechnologies.com/api/courses/api/downloads';


export default function AdminDownloads() {
  const [items, setItems] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [editingItem, setEditingItem] = useState(null);

  const [headerTitle, setHeaderTitle] = useState('Admission Documents');
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [createdDate, setCreatedDate] = useState(new Date().toISOString().split('T')[0]);
  const [createdTime, setCreatedTime] = useState(new Date().toTimeString().split(' ')[0].slice(0, 5));
  const [isNew, setIsNew] = useState(true);
  const [file, setFile] = useState(null);

  const fetchDownloads = async () => {
    try {
      const res = await fetch(API_URL);
      const data = await res.json();
      setItems(data);
    } catch (err) {
      console.error('Error fetching downloads:', err);
    }
  };

  useEffect(() => {
    fetchDownloads();
  }, []);

  // Format Date and Time for Table Display
  const formatTableDateTime = (dateStr, timeStr) => {
    if (!dateStr) return '';
    const isoString = timeStr ? `${dateStr.split('T')[0]}T${timeStr}` : dateStr;
    const dateObj = new Date(isoString);
    
    if (isNaN(dateObj.getTime())) return dateStr;

    return dateObj.toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    });
  };

  const openModal = (item = null) => {
    if (item) {
      setEditingItem(item);
      setHeaderTitle(item.header_title);
      setTitle(item.title);
      setDescription(item.description || '');
      setCreatedDate(item.created_date ? item.created_date.split('T')[0] : new Date().toISOString().split('T')[0]);
      setCreatedTime(item.created_time || new Date().toTimeString().split(' ')[0].slice(0, 5));
      setIsNew(Boolean(item.is_new));
      setFile(null);
    } else {
      setEditingItem(null);
      setHeaderTitle('Admission Documents');
      setTitle('');
      setDescription('');
      setCreatedDate(new Date().toISOString().split('T')[0]);
      setCreatedTime(new Date().toTimeString().split(' ')[0].slice(0, 5));
      setIsNew(true);
      setFile(null);
    }
    setModalOpen(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append('header_title', headerTitle);
    formData.append('title', title);
    formData.append('description', description);
    formData.append('created_date', createdDate);
    formData.append('created_time', createdTime);
    formData.append('is_new', isNew);
    if (file) {
      formData.append('file', file);
    }

    const method = editingItem ? 'PUT' : 'POST';
    const url = editingItem ? `${API_URL}/${editingItem.id}` : API_URL;

    try {
      const res = await fetch(url, {
        method,
        body: formData,
      });

      if (res.ok) {
        setModalOpen(false);
        fetchDownloads();
      } else {
        alert('Failed to save document.');
      }
    } catch (err) {
      console.error('Submit error:', err);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this document?')) {
      try {
        await fetch(`${API_URL}/${id}`, { method: 'DELETE' });
        fetchDownloads();
      } catch (err) {
        console.error('Delete error:', err);
      }
    }
  };

  return (
    <div style={{ maxWidth: '1000px', margin: '30px auto', padding: '20px', fontFamily: 'sans-serif' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <h2>Admin Downloads Manager</h2>
        <button
          onClick={() => openModal()}
          style={{ padding: '10px 18px', backgroundColor: '#1d4ed8', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold' }}
        >
          + Add New Document
        </button>
      </div>

      <table style={{ width: '100%', borderCollapse: 'collapse', backgroundColor: '#fff', boxShadow: '0 2px 8px rgba(0,0,0,0.05)', borderRadius: '8px', overflow: 'hidden' }}>
        <thead>
          <tr style={{ backgroundColor: '#f1f5f9', textAlign: 'left' }}>
            <th style={{ padding: '12px' }}>Category</th>
            <th style={{ padding: '12px' }}>Title & Description</th>
            <th style={{ padding: '12px' }}>Date & Time Posted</th>
            <th style={{ padding: '12px' }}>File</th>
            <th style={{ padding: '12px' }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item) => (
            <tr key={item.id} style={{ borderBottom: '1px solid #e2e8f0' }}>
              <td style={{ padding: '12px', fontWeight: 'bold', color: '#1e3a8a' }}>{item.header_title}</td>
              <td style={{ padding: '12px' }}>
                <div style={{ fontWeight: 'bold' }}>{item.title}</div>
                <div style={{ fontSize: '12px', color: '#64748b' }}>{item.description}</div>
              </td>
              <td style={{ padding: '12px', fontSize: '13px', color: '#64748b', fontWeight: '500' }}>
                📅 {formatTableDateTime(item.created_date, item.created_time)}
              </td>
              <td style={{ padding: '12px' }}>
                <a href={`https://metapi.emedhatechnologies.com${item.file_path}`} target="_blank" rel="noreferrer" style={{ color: '#2563eb', fontWeight: 'bold' }}>
                  View PDF
                </a>
              </td>
              <td style={{ padding: '12px' }}>
                <button onClick={() => openModal(item)} style={{ marginRight: '8px', padding: '6px 12px', background: '#e2e8f0', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>
                  Edit
                </button>
                <button onClick={() => handleDelete(item.id)} style={{ padding: '6px 12px', background: '#ffe4e6', color: '#be123c', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Modal Dialog */}
      {modalOpen && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ backgroundColor: '#fff', padding: '24px', borderRadius: '12px', width: '480px' }}>
            <h3>{editingItem ? 'Edit Document' : 'Upload Document'}</h3>
            <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginTop: '16px' }}>
              
              <label style={{ fontSize: '12px', fontWeight: 'bold' }}>Header Title (Category)</label>
              <select value={headerTitle} onChange={(e) => setHeaderTitle(e.target.value)} style={{ padding: '8px', borderRadius: '6px', border: '1px solid #ccc' }}>
                <option value="Admission Documents">Admission Documents</option>
                <option value="Study Materials">Study Materials</option>
                <option value="Examination">Examination</option>
                <option value="Assignment">Assignment</option>
                <option value="Results">Results</option>
                <option value="Certificates & Transcripts">Certificates & Transcripts</option>
              </select>

              <label style={{ fontSize: '12px', fontWeight: 'bold' }}>Document Title</label>
              <input type="text" value={title} onChange={(e) => setTitle(e.target.value)} required placeholder="Enter title" style={{ padding: '8px', borderRadius: '6px', border: '1px solid #ccc' }} />

              <label style={{ fontSize: '12px', fontWeight: 'bold' }}>Description (Optional)</label>
              <textarea value={description} onChange={(e) => setDescription(e.target.value)} placeholder="Enter details..." style={{ padding: '8px', borderRadius: '6px', border: '1px solid #ccc', resize: 'none' }} />

              <div style={{ display: 'flex', gap: '10px' }}>
                <div style={{ flex: 1 }}>
                  <label style={{ fontSize: '12px', fontWeight: 'bold' }}>Date</label>
                  <input type="date" value={createdDate} onChange={(e) => setCreatedDate(e.target.value)} required style={{ width: '100%', padding: '8px', borderRadius: '6px', border: '1px solid #ccc', boxSizing: 'border-box' }} />
                </div>
                <div style={{ flex: 1 }}>
                  <label style={{ fontSize: '12px', fontWeight: 'bold' }}>Time</label>
                  <input type="time" value={createdTime} onChange={(e) => setCreatedTime(e.target.value)} required style={{ width: '100%', padding: '8px', borderRadius: '6px', border: '1px solid #ccc', boxSizing: 'border-box' }} />
                </div>
              </div>

              <label style={{ fontSize: '12px', fontWeight: 'bold' }}>PDF / Document File</label>
              <input type="file" onChange={(e) => setFile(e.target.files[0])} required={!editingItem} accept=".pdf,.doc,.docx" style={{ padding: '4px' }} />

              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <input type="checkbox" id="badgeNew" checked={isNew} onChange={(e) => setIsNew(e.target.checked)} />
                <label htmlFor="badgeNew" style={{ fontSize: '13px' }}>Mark as "NEW" badge</label>
              </div>

              <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '12px' }}>
                <button type="button" onClick={() => setModalOpen(false)} style={{ padding: '8px 16px', background: '#e2e8f0', border: 'none', borderRadius: '6px', cursor: 'pointer' }}>Cancel</button>
                <button type="submit" style={{ padding: '8px 16px', background: '#1d4ed8', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer' }}>Save Document</button>
              </div>

            </form>
          </div>
        </div>
      )}
    </div>
  );
}